function downloadFromBlob(filename: string, blob: Blob) {
    // Create a URL for the blob
    let url: string | undefined;
    try {
        url = URL.createObjectURL(blob);
        // Create a link element
        const link = document.createElement('a');
        // Set the link element's href to the url
        link.href = url;
        // Set the link element's download attribute to the filename
        link.download = filename;
        // Append the link element to the document body
        document.body.appendChild(link);
        // Click the link element
        link.click();
        // Remove the link element from the document body
        document.body.removeChild(link);
    } finally {
        // Revoke the URL if it was created
        if (url) {
            URL.revokeObjectURL(url);
        }
    }
}

export default downloadFromBlob;
